export default __webpack_public_path__ + "static/media/project-wizard-milestones.d8b11df4.png";